
import { Question } from '../types';

export const taj101IstiadhaBasmalahQuestions: Question[] = [
  {
    id: 'taj021',
    text: 'What are the key terms related to combining istiʿādhah and basmalah in recitation?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Faṣl (to separate)', isCorrect: true },
      { id: 'b', text: 'Waṣl (to join)', isCorrect: true },
      { id: 'c', text: 'Al-awwal (the first)', isCorrect: true },
      { id: 'd', text: 'Ath-thānī (the second)', isCorrect: true }
    ],
    explanation: 'The key terms related to combining istiʿādhah and basmalah are: faṣl (to separate), waṣl (to join), al-awwal (the first), and ath-thānī (the second). These terms describe how to connect or separate these phrases in recitation.',
    topic: 'taj101'
  },
  {
    id: 'taj022',
    text: 'How many situations can a reciter find themselves in when reciting both the istiʿādhah and the basmalah?',
    type: 'single',
    options: [
      { id: 'a', text: 'Three situations', isCorrect: true },
      { id: 'b', text: 'Two situations', isCorrect: false },
      { id: 'c', text: 'Four situations', isCorrect: false },
      { id: 'd', text: 'Five situations', isCorrect: false }
    ],
    explanation: 'When discussing the istiʿādhah and the basmalah, the qāriʾ will find himself in one of three situations: starting at the beginning of a surah, starting in the middle of a surah, or ending a surah and starting another.',
    topic: 'taj101'
  },
  {
    id: 'taj023',
    text: 'When starting recitation at the beginning of a surah, how many ways are there to recite the istiʿādhah and basmalah?',
    type: 'single',
    options: [
      { id: 'a', text: 'Four ways', isCorrect: true },
      { id: 'b', text: 'Two ways', isCorrect: false },
      { id: 'c', text: 'Three ways', isCorrect: false },
      { id: 'd', text: 'Five ways', isCorrect: false }
    ],
    explanation: 'When starting recitation at the beginning of a surah, there are four possible ways to recite the istiʿādhah and basmalah: waṣl al-kul (joining everything), faṣl al-awwal waṣl ath-thānī (separating the first, joining the second), faṣl al-kul (separating everything), and waṣl al-awwal faṣl ath-thānī (joining the first, separating the second).',
    topic: 'taj101'
  },
  {
    id: 'taj024',
    text: 'What does "waṣl al-kul" mean when reciting istiʿādhah and basmalah?',
    type: 'single',
    options: [
      { id: 'a', text: 'To join everything (istiʿādhah to basmalah, and basmalah to the surah)', isCorrect: true },
      { id: 'b', text: 'To separate everything', isCorrect: false },
      { id: 'c', text: 'To join only the istiʿādhah to the basmalah', isCorrect: false },
      { id: 'd', text: 'To join only the basmalah to the surah', isCorrect: false }
    ],
    explanation: '"Waṣl al-kul" means to join everything, i.e., to join the istiʿādhah to the basmalah, and the basmalah to the beginning of the surah without pausing between them.',
    topic: 'taj101'
  },
  {
    id: 'taj025',
    text: 'When starting recitation in the middle of a surah, which two ways are preferred for beginners?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'Faṣl al-kul (separating everything)', isCorrect: true },
      { id: 'b', text: 'Waṣl al-awwal faṣl ath-thānī (joining the first, separating the second)', isCorrect: true },
      { id: 'c', text: 'Waṣl al-kul (joining everything)', isCorrect: false },
      { id: 'd', text: 'Faṣl al-awwal waṣl ath-thānī (separating the first, joining the second)', isCorrect: false }
    ],
    explanation: 'When starting recitation in the middle of a surah, two ways are preferred for beginners: faṣl al-kul (separating the istiʿādhah from the basmalah, and separating the basmalah from the middle of the surah) and waṣl al-awwal faṣl ath-thānī (joining the istiʿādhah to the basmalah, and separating the basmalah from the middle of the surah).',
    topic: 'taj101'
  },
  {
    id: 'taj026',
    text: 'When ending one surah and starting another, which way of combining istiʿādhah and basmalah is NOT allowed?',
    type: 'single',
    options: [
      { id: 'a', text: 'Waṣl al-awwal faṣl ath-thānī', isCorrect: true },
      { id: 'b', text: 'Faṣl al-kul', isCorrect: false },
      { id: 'c', text: 'Waṣl al-kul', isCorrect: false },
      { id: 'd', text: 'Faṣl al-awwal waṣl ath-thānī', isCorrect: false }
    ],
    explanation: 'When ending one surah and starting another, "waṣl al-awwal faṣl ath-thānī" (joining the end of the first surah to the basmalah and separating the basmalah from the beginning of the second surah) is not allowed. This is because it would leave the impression that the basmalah is part of the end of the first surah, which is not the case.',
    topic: 'taj101'
  },
  {
    id: 'taj027',
    text: 'What is the rule regarding reciting the basmalah at the beginning of Sūrah at-Tawbah?',
    type: 'single',
    options: [
      { id: 'a', text: 'The basmalah should not be recited', isCorrect: true },
      { id: 'b', text: 'The basmalah must be recited', isCorrect: false },
      { id: 'c', text: 'The basmalah is optional', isCorrect: false },
      { id: 'd', text: 'The basmalah is recited twice', isCorrect: false }
    ],
    explanation: 'The basmalah should not be recited at the beginning of Sūrah at-Tawbah. This is the only surah in the Qur\'ān that does not begin with the basmalah.',
    topic: 'taj101'
  },
  {
    id: 'taj028',
    text: 'In the third situation (already started recitation, ending one surah and starting another), how many ways of reciting are allowed?',
    type: 'single',
    options: [
      { id: 'a', text: 'Three ways', isCorrect: true },
      { id: 'b', text: 'Four ways', isCorrect: false },
      { id: 'c', text: 'Two ways', isCorrect: false },
      { id: 'd', text: 'One way', isCorrect: false }
    ],
    explanation: 'In the third situation (already started recitation, ending one surah and starting another), three ways are allowed: faṣl al-kul (separating everything), waṣl al-kul (joining everything), and faṣl al-awwal waṣl ath-thānī (separating the first surah from the basmalah and joining the basmalah to the beginning of the second surah).',
    topic: 'taj101'
  },
  {
    id: 'taj029',
    text: 'What is the meaning of "faṣl al-kul" when reciting istiʿādhah and basmalah?',
    type: 'single',
    options: [
      { id: 'a', text: 'To separate everything (make pauses between all parts)', isCorrect: true },
      { id: 'b', text: 'To join everything without pauses', isCorrect: false },
      { id: 'c', text: 'To separate only the istiʿādhah from the basmalah', isCorrect: false },
      { id: 'd', text: 'To separate only the basmalah from the surah', isCorrect: false }
    ],
    explanation: '"Faṣl al-kul" means to separate everything, i.e., to separate the istiʿādhah from the basmalah, and to separate the basmalah from the beginning of the surah by making pauses between all parts.',
    topic: 'taj101'
  },
  {
    id: 'taj030',
    text: 'What does "faṣl al-awwal waṣl ath-thānī" mean when reciting istiʿādhah and basmalah?',
    type: 'single',
    options: [
      { id: 'a', text: 'To separate the istiʿādhah from the basmalah and join the basmalah to the surah', isCorrect: true },
      { id: 'b', text: 'To join the istiʿādhah to the basmalah and separate the basmalah from the surah', isCorrect: false },
      { id: 'c', text: 'To separate everything', isCorrect: false },
      { id: 'd', text: 'To join everything', isCorrect: false }
    ],
    explanation: '"Faṣl al-awwal waṣl ath-thānī" means to separate the first (the istiʿādhah from the basmalah) and join the second (the basmalah to the beginning of the surah).',
    topic: 'taj101'
  }
];
